exports.extract = require('./extract')
exports.pack = require('./pack')



//////////////////
// WEBPACK FOOTER
// ./node_modules/tar-stream/index.js
// module id = 674
// module chunks = 0